// <%= simple_form_for @model, url: '/...', html: { data: { controller: 'ajax-form', done: "SideDialog.close(); $('#main').reload();" } } do |form| %>

import BaseController from "./base_controller"

export default class AjaxFormController extends BaseController {
  connect() {
    this.element.onsubmit = this.submit.bind(this)
  }

  submit(e) {
    e.preventDefault()

    const formNode = $(e.target)
    const formData = this.formData(formNode[0])
    const action = this.element.getAttribute('action')

    let xhr = new XMLHttpRequest();

    xhr.open('POST', action, true);

    xhr.onload = () => {
      var value, response;

      // enable disabled buttons
      formNode.find('input[type=submit][disabled]').removeAttr('disabled')

      if (xhr.responseText) {
        response = JSON.parse(xhr.responseText);
      } else {
        Toastify.error('Empty response from server - network error?')
        return
      }

      if (!(formNode.attr('silent') || formNode.attr('data-silent'))) {
        Toastify.show(response)
      }

      if (xhr.status === 200) {
        // ajax reload dom node element
        if (value = formNode.data('reload')) {
          $(value).reload()
        }

        // execute function on done, pass response
        // { data: { controller: 'ajax-form', done: "SideDialog.close(); $('#main').reload();" }
        if (value = formNode.data('done')) {
          (new Function('r', value))(response)
        }
      }
    };

    xhr.send(formData);
  }

  formData(node) {
    let file;
    const formData = new FormData(node)

    node.querySelectorAll('input[type=file]').forEach( (el) => {
      if (file = el.files[0]) {
        let fileBlob = new Blob([file], { type: file.type });
        formData.append(el.name, fileBlob, file.name);
      } else {
        formData.delete(el.name)
      }
    })

    return formData
  }
}
